module.exports = __webpack_public_path__ + "media/images/emblems/Bardonnex-coat_of_arms-5827efa01bf77dce0d18b5c5a05491bf.svg";